import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// delon
import { AlainThemeModule } from '@delon/theme';
import { DelonABCModule } from '@delon/abc';
import { DelonACLModule } from '@delon/acl';
import { DelonFormModule } from '@delon/form';
import { DelonChartModule } from '@delon/chart';
// i18n
import { TranslateModule } from '@ngx-translate/core';

import { EditorModule } from '@tinymce/tinymce-angular';
// region: third libs
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { CountdownModule } from 'ngx-countdown';
import { DictSearchrComponent } from './components/dict-search/dict-search';
import { DictSpanComponent } from './components/dict-search/dict-span';
import { FileUploadComponent } from './components/file-upload/file-upload';
import { ExcelOutputComponent } from './components/excel/excel-output';
import { ExcelInputComponent } from './components/excel/excel-input';
import { CommonBrowseComponent } from '@shared/components/browse/common.browse.component';
import { UserBrowseComponent } from '@shared/components/browse/user/user.browse.component';
import { PersonBrowseComponent } from '@shared/components/browse/person/person.browse.component';
import { BrowseDirective } from '@shared/components/browse/browse.directive';
import { BizSelectComponent, EXE_COUNTER_VALUE_ACCESSOR } from '@shared/components/biz-select/biz-select.component';
import { ExtendFieldFormComponent } from '@shared/components/extend-field/extend-field-form.component';
import { CommonProcessFlowComponent } from '@shared/components/process-flow/process-flow.component';
import { RoleBrowseComponent } from '@shared/components/browse/role/role.browse.component';
import { SortPipe } from '@shared/pipe/sort.pipe';
import { ProcessComponent } from './components/browse/process/process.component';
import { PersonCardComponent } from './components/person-card/person-card';
import { PaginationSearchComponent } from './components/pagination-search/pagination-search';
import { ArticleComponent } from './components/article/article.component';
import { MsgTemplateBrowseComponent } from '@shared/components/browse/msg-template-browse/msg-template-browse.component';
import { SupplierComponent } from './components/browse/supplier/supplier.component';

import { IndicatorsComponent } from './components/browse/indicators/indicators.component';

import { MaterialBrowseComponent } from '@shared/components/browse/material/material.browse.component';
import { DynamicFormValueComponent } from '@shared/components/dynamic-form-value/dynamic-form-value.component';
import { SuAssPlanComponent } from './components/browse/su-ass-plan/su-ass-plan.component';
import { SupPurorgBrowseComponent } from './components/browse/sup-purorg/supPurorg.component';
import { PurgrpBrowseComponent } from './components/browse/purgrp/purgrp.component';
import { PurorgBrowseComponent } from './components/browse/purorg/purorg.component';
import { PlantComponent } from './components/browse/plant/plant.component';
import { SrmMenuComponent } from './components/srm-menu/srm-menu.component';
import { ScorePlanComponent } from './components/score/score-plan/score-plan.component';

import { PriceDetailsComponent } from './components/price-details/price-details.component';

import { MarkingPlanComponent } from './components/browse/marking-plan/marking-plan.component';
import { ExpertBrowseComponent } from '@shared/components/browse/expert/expert.browse.component';
import { RandomExpertsComponent } from './components/score/random-experts/random-experts.component';
import { TaxBrowseComponent } from './components/browse/tax/tax.component';
import { ScoringComponent } from './components/score/scoring/scoring.component';
import { ScoringComponentComponent } from './components/score/scoring-component/scoring-component.component';
import { ScorePlanComponentComponent } from './components/score/score-plan-component/score-plan-component.component';
import { ExcelInputFrontComponent } from './components/excel-input-front/excel-input-front.component';
import { PriceBrowseComponent } from '@shared/components/browse/price/price.browse.component';
import { StorageLocationBrowseComponent } from './components/browse/storage-location/storage-location.component';
import { CertificateBrowseComponent } from '@shared/components/browse/certificate/certificate.browse.component';
import { CompanyComponent } from './components/browse/company/company.component';
import { SoaDrawerSearchPsbComponent } from './components/soa-drawer-searchPsb/soa-drawer-searchPsb.component';

import { PurchaseOrderComponent } from './components/browse/purchase-order/purchase-order.component';

import { ValidateCodeComponent } from '@shared/components/validate-code/validate-code.component';
import { SupplierInviteButtonComponent } from './components/supplier-invite-button/supplier-invite-button.component';
import { SupDetailLinkComponent } from './components/sup-detail-link/sup-detail-link';
import { AddressBrowseComponent } from '@shared/components/browse/address/address.component';
import { PurOrderToAskGoods } from '@shared/components/browse/purOrderToAskGoods/purOrderToAskGoods';
import { AsnBrowseComponent } from '@shared/components/browse/asn/asn.browse.component';
import { StockTableDtBrowseComponent } from './components/browse/stock-table-dt-browse/stock-table-dt-browse.component';
import { QuickSearchComponent } from '@shared/components/quick-search/quick-search.component';
import { AdvSortPipe } from '@shared/pipe/adv-sort.pipe';
import { LinkFlowComponent } from '@shared/components/link-flow/link-flow.component';
import { PurchaseOrderLineComponent } from './components/browse/purchase-order-line/purchase-order-line.component';
import { SelectMultipleComponent } from './components/select-multiple/select-multiple.component';
import { ClaimDtComponent } from '@shared/components/browse/claim-dt/claim-dt.component';
import { MobilePhoneDirective } from '@shared/components/directive/mobile-phone-directive';
import { LadderQuotationComponent } from './components/ladder-quotation/ladder-quotation.component';
import { PriceReducitonComponent } from './components/price-reduciton/price-reduciton.component';
import { ArticleBrowseComponent } from './components/browse/article/article.browse.component';
import { PriceRepositoryBrowseComponent } from '@shared/components/browse/priceRepositoryBrowse/price-repository-browse';
import { SupplierRotationComponent } from './components/browse/supplier-rotation/supplier-rotation.component';
import { SourceTypeBrowseComponent } from './components/browse/source-type/source-type.browse.component';
import { ReferenceDocumentBrowseComponent } from './components/browse/reference-document/reference-document.browse.component';
import { InvoiceMethodsComponent } from './components/browse/invoice-methods/invoice-methods.component';
import { BrowseButtonComponent } from './components/browse-button/browse-button.component';
import { CommodityInfoComponent } from './components/browse/commodity-info/commodity-info.component';
import { ActionBrowseComponent } from '@shared/components/browse/action/action.browse.component';
import { SupplySelectComponent } from './components/supply-select/supply-select.component';
import { ErrorSrcDirective } from '@shared/directive/error-src.directive';
import { SupplierDynamicFormValueComponent } from './components/supplier-dynamic-form-value/supplier-dynamic-form-value.component';
import { RolePersonBrowseComponent } from '@shared/components/browse/rolePerson/rolePerson.browse.component';
import { JgridComponent } from '@shared/components/tadpole/jgrid.component';
import { ShareSubclassBrowseComponent } from './components/browse/share-subclass/share-subclass-browse.component';
import { ArticleCommentComponent } from './components/article-comment/article-comment.component';
import { ArticleViewComponent } from './components/article-view/article-view.component';
import { MatCategoryBrowseComponent } from '@shared/components/browse/mat-category/mat-category.browse.component';
import { MatTypeMaterialBrowseComponent } from '@shared/components/browse/mat-type-material/mat-type-material.browse.component';
import { MatgrpBrowseComponent } from '@shared/components/browse/matgrp/matgrp.browse.component';
import { InquiryDocumentBrowseComponent } from '@shared/components/browse/inquiry-document/reference-document.browse.component';
import { BrowserCommonsComponent } from './components/browser-commons/browser-commons.component';
import { InquiryTypeBrowseComponent } from '@shared/components/browse/inquiry-type/inquiry-type.browse.component';
import { ComponentModelBrowseComponent } from '@shared/components/browse/compact-model/component-model-browse.component';
import { SearchPipe } from './pipe/search.pipe';
import { SearchBrowseComponent } from './components/search-browse/search-browse.component';
import { SuAssGatherDetailComponent } from './components/browse/su-ass-gather-detail/su-ass-gather-detail.component';
import { ArrivalConfirmBrowseComponent } from '@shared/components/browse/arrivalConfirm/arrivalConfirm.browse.component';
import { AttachmentSrcDirective } from '@shared/directive/attachment-src.directive';
import { AttachmentSrcPipe } from '@shared/pipe/attachment-src.pipe';
import { SapBrowserCommonsComponent } from './components/sap-browser-commons/sap-browser-commons.component';
import { SoaBrowseComponent } from './components/browse/soa/soa.browse.component';
import { CompactBrowseComponent } from './components/browse/compact/compact.browse.component';
import { PurRequisitionBrowseComponent } from '@shared/components/browse/pur-requisition/pur-requisition.browse.component';
import { SupTypeComponent } from './components/browse/sup-type/sup-type.component';
import { BanksComponent } from '@shared/components/bank/bank.component';
import { SupAssQuailDtComponent } from './components/browse/sup-ass-quail-dt/sup-ass-quail-dt.component';
import { TenderMatDetailComponent } from './components/tender-mat-detail/tender-mat-detail.component';
import {PriceComparisonBrowse} from "@shared/components/browse/PriceComparison/Price-comparison-browse";
import {SupplyTypeComponent} from "@shared/components/browse/supplytype/supplyType.component";
import { SourcingBrowseComponent } from './components/browse/sourcing-browse/sourcing-browse.component';


//CostCenter
// import {TinyEditorComponent} from "./components/tiny-mce/tiny-mce";
const THIRDMODULES = [
  NgZorroAntdModule,
  CountdownModule,
];
// endregion

// region: your componets & directives
const COMPONENTS = [
  SupAssQuailDtComponent,
  PaginationSearchComponent,
  ExcelInputFrontComponent,
  PersonCardComponent,
  SuAssGatherDetailComponent,
  SupplierInviteButtonComponent,
  SupDetailLinkComponent,
  DictSearchrComponent,

  DictSpanComponent,
  ExcelInputComponent,
  ExcelOutputComponent,
  FileUploadComponent,
  CommonBrowseComponent,
  ExtendFieldFormComponent,
  DynamicFormValueComponent,
  CommonProcessFlowComponent,
  BizSelectComponent,
  ArticleComponent,
  SrmMenuComponent,
  ScorePlanComponent,
  RandomExpertsComponent,
  PriceDetailsComponent,
  ScoringComponent,
  ScoringComponentComponent,
  ScorePlanComponentComponent,
  ValidateCodeComponent,
  QuickSearchComponent,
  LinkFlowComponent,
  SelectMultipleComponent,
  LadderQuotationComponent,
  PriceReducitonComponent,
  BrowseButtonComponent,
  SupplySelectComponent,
  SupplierDynamicFormValueComponent,
  JgridComponent,
  ArticleCommentComponent,
  ArticleViewComponent,
  BrowserCommonsComponent,
  SapBrowserCommonsComponent,
  SearchBrowseComponent,
  TenderMatDetailComponent
];


const BROWSE_COMPONENTS = [
  SupAssQuailDtComponent,
  CompactBrowseComponent,
  BanksComponent,
  SoaBrowseComponent,
  PurOrderToAskGoods,
  ArticleBrowseComponent,
  SuAssGatherDetailComponent,
  TaxBrowseComponent,
  AddressBrowseComponent,
  StorageLocationBrowseComponent,
  UserBrowseComponent,
  MsgTemplateBrowseComponent,
  PurorgBrowseComponent,
  RoleBrowseComponent,
  SupPurorgBrowseComponent,
  PurgrpBrowseComponent,
  PersonBrowseComponent,
  ProcessComponent,
  SupplierComponent,
  MaterialBrowseComponent,
  IndicatorsComponent,
  SuAssPlanComponent,
  SupplierRotationComponent,
  InquiryTypeBrowseComponent,
  SourceTypeBrowseComponent,
  InquiryDocumentBrowseComponent,
  ArrivalConfirmBrowseComponent,
  ReferenceDocumentBrowseComponent,
  PlantComponent,
  MarkingPlanComponent,
  ExpertBrowseComponent,
  PriceBrowseComponent,
  CertificateBrowseComponent,
  PriceRepositoryBrowseComponent,
  CompanyComponent,
  SoaDrawerSearchPsbComponent,
  PurchaseOrderComponent,
  PurchaseOrderLineComponent,
  AsnBrowseComponent,
  StockTableDtBrowseComponent,
  ClaimDtComponent,
  InvoiceMethodsComponent,
  ActionBrowseComponent,
  CommodityInfoComponent,
  RolePersonBrowseComponent,
  ShareSubclassBrowseComponent,
  MatCategoryBrowseComponent,
  MatTypeMaterialBrowseComponent,
  MatgrpBrowseComponent,
  ComponentModelBrowseComponent,
  PurRequisitionBrowseComponent,
  SupTypeComponent,
  PriceComparisonBrowse,
  SupplyTypeComponent,
  SourcingBrowseComponent
];

const FLOW_COMPONENTS = [CommonProcessFlowComponent];
const DIRECTIVES = [BrowseDirective, MobilePhoneDirective, ErrorSrcDirective, AttachmentSrcDirective];
const PIPE = [SortPipe, AdvSortPipe, SearchPipe, AttachmentSrcPipe];

// endregion

@NgModule({
  imports: [
    EditorModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonABCModule,
    DelonChartModule,
    DelonACLModule,
    DelonFormModule,
    // i18n
    TranslateModule,
    // third libs
    ...THIRDMODULES,
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...BROWSE_COMPONENTS,
    ...FLOW_COMPONENTS,
    ...DIRECTIVES,
    ...PIPE,
    IndicatorsComponent,
    SuAssPlanComponent,
    PlantComponent,
    PurchaseOrderLineComponent,
    SupplySelectComponent,
    SuAssGatherDetailComponent,
    SupAssQuailDtComponent,
    SourcingBrowseComponent
  ],
  exports: [
    EditorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonABCModule,
    DelonChartModule,
    DelonFormModule,
    DelonACLModule,
    // i18n
    TranslateModule,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...BROWSE_COMPONENTS,
    ...DIRECTIVES,
    ...PIPE,
  ],
  providers: [EXE_COUNTER_VALUE_ACCESSOR, AttachmentSrcPipe],
  entryComponents: [...BROWSE_COMPONENTS],
})
export class SharedModule {
}
